// extracted by mini-css-extract-plugin
export default {"wrapper":"fm5gOg","container":"IkhScj","content":"VnA9yG"};